// extracted by mini-css-extract-plugin
export default {"headingContainer":"login_headingContainer__682+Q"};